<template>
  <svg
    width="20"
    height="20"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <line class="cls-1" x1="5.26" y1="18.86" x2="5.26" y2="25.4" />
    <line class="cls-1" x1="11.31" y1="13.85" x2="11.31" y2="25.4" />
    <line class="cls-1" x1="17.22" y1="8.26" x2="17.22" y2="25.4" />
    <line class="cls-1" x1="23.15" y1="3.91" x2="23.15" y2="25.4" />
  </svg>
</template>

<script>
export default {
  name: 'AbonnementIcon'
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

line {
  fill: none;
  stroke: $primary;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
